module.exports = __webpack_public_path__ + "static/media/location.cca07081.svg";